<template>
    <v-form
        v-model="inputs_valid"
        action="/login"
        method="post"
        ref="login_form"
        class="px-0 mx-0"
        v-on:submit.prevent
    >

        <v-container>
            <v-row>
                <v-text-field v-show="false" type="hidden" id="_token" name="_token" v-model="token"/>
                <v-text-field v-show="false" type="hidden" id="device" name="device" v-model="device"/>

                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="email"
                        :rules="email_rules"
                        label="Email"
                        id="email"
                        type="email"
                        name="email"
                        :error-messages="errors?.email"
                        required
                        autofocus
                    ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                    <v-btn
                        type="submit"
                        @click="requestPwReset"
                        :disabled="!inputs_valid"
                        class="main-btn"
                    >
                        Continue
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>


    </v-form>
</template>

<script>

import {DeviceUUID} from 'device-uuid';

export default {
    name: "AuthBarForgotPw",

    data: () => ({
        inputs_valid: false,
        email: '',
        email_rules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],

        token: null,
        device: null,
        expanded_panel_index: null,
        errors: null,
    }),

    computed: {
        payload: function () {
            return {
                email: this.email,
                device: this.device,
            }
        },
    },

    methods: {
        reset () {
            this.expanded_panel_index = null
            this.$nextTick(()=>{
                this.$refs.login_form.reset()
            })
        },
        resetValidation () {
            this.$refs.login_form.resetValidation()
            this.errors = null
        },
        getDeviceId () {
            return new DeviceUUID().get()
        },
        getToken () {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        async requestPwReset () {
            axios.post('forgot-password', this.payload)
                .then((response) => {
                    if( response.data.data && response.data.data.success) {
                        this.$root.snackbar.success(response.data.data.message)
                        this.$emit('close')
                    } else {
                        let message = response.data.data.message || "Error sending password reset"
                        this.$root.snackbar.error(message)
                    }
                })
                .catch((error) => {
                    if( error?.response ) {
                        this.$root.snackbar.error(error.response.data.data.message)
                        this.errors = error.response?.data?.data?.errors
                    } else {
                        this.$root.snackbar.error(error)
                    }
                })
        },
    },

    created() {
        this.requestPwReset = _.debounce(this.requestPwReset, 666) // Replace this function with a debounced version of itself
    },

    mounted() {
        this.token = this.getToken()
        this.device = this.getDeviceId()
    },
    watch: {
        email(newValue, oldValue) {
            this.resetValidation()
        },
    }
}
</script>
